import { Stack } from "@mui/material";
import { T } from "components/util/t";
import { Link } from "react-router-dom";
import { Sx } from "utils/sx";
import { isTeamFormat } from "utils/utils";
import { EventCard } from "./eventCard/EventCard";
import { EventCardTopLabel } from "./eventCard/EventCardTopLabel";
import { EventCardMainSection } from "./eventCard/EventCardMainSection";
import { EventCardTitle } from "./eventCard/EventCardTitle";
import { RecentlyViewedEventDivision } from "./useRecentlyViewed";
import { trackClick, trackingCategory } from "utils/tracking";

export const RecentlyViewedEventDivisionCard: React.FC<{
    item: RecentlyViewedEventDivision;
    sx?: Sx;
}> = ({ item, sx }) => {
    const baseLink = `/events/${item.data.event.id}/divisions/${item.data.eventDivisionId || item.data.id}`;

    return (
        <Link
            to={baseLink}
            aria-label={item.data.division.name}
            onClick={trackClick(
                "Division card",
                trackingCategory.recentlyViewed,
            )}
        >
            <EventCard sx={sx}>
                <EventCardMainSection sx={{ flex: 1 }}>
                    <EventCardTopLabel date={item.data.event.name} />
                    <EventCardTitle title={item.data.division.name} />
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        data-testid="event-card-location"
                    >
                        <div>
                            <T count={item.data.entryCount}>
                                {isTeamFormat(item.data.formatDefinition)
                                    ? "team_count"
                                    : "athlete_count"}
                            </T>
                        </div>
                    </Stack>
                </EventCardMainSection>
            </EventCard>
        </Link>
    );
};
